import BlogThirtySevenContainer from "./container/BlogThirtySevenContainer";
export default BlogThirtySevenContainer;
